import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import rootReducer from './reducers';
import { versionApi } from './reducers/version/versionSlice';
import { pokemonApi } from './reducers/pokemon/pokemonSlice';
import { usergroupApi } from './reducers/usergroup/usergroupSlice';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware()
        .concat(versionApi.middleware)
        .concat(pokemonApi.middleware)
        .concat(usergroupApi.middleware)
  }
});

setupListeners(store.dispatch);

export type AppDispatch = typeof store.dispatch;
